// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lZj_","colBig":"styles_colBig__1zC-f","colSmall":"styles_colSmall__1iAwz","shopifyNameWrapper":"styles_shopifyNameWrapper__2K0EN"};